// API endpoint routes across the banking platform
export const API_ROUTES = Object.freeze({
  AUTH: {
    LOGIN: "/accounts/login/",
    OTP_SEND: "/accounts/otp_send/",
    STAFF_ACTIVATION: "/accounts/toggle_staff_activation/",
    LOGS: "/accounts/get_logs/",
  },
  APPLICATIONS: {
    SUBMIT: "/applications/members_declaration/",
    SINGLE_DETAILS: (id) => `/applications/single_application_details/${id}/`,
    PDF_EXPORT: (id) => `/applications/application_pdf/${id}/`,
    ALL_DETAILS: "/applications/all_application_details/",
    APPROVED: "/applications/approved_applications/",
    REJECTED: "/applications/rejected_applications/",
    INCOMPLETE: "/applications/incomplete_applications/",
    SUBMITTED_UNDER: "/applications/submitted_Under/",
    MEMBER_COUNT: "/applications/all_member_count/",
    NOTIFICATIONS: "/applications/kick_notif/",
    UPDATE_STATUS: "/applications/updateappstatus/",
  },
  STAFF: {
    LIST: "/applications/admin_staffwise_stats/",
    ARCHIVED: "/applications/archived_staff_member/",
  },
});
